<template>
  <v-dialog
    v-model="shown"
    max-width="967"
    @click:outside="cancel"
  >
  <div v-if="asyncDataStatus_ready" class="col-full popup">
    <h2>
      Uredite mizo:
    </h2>

    <TableForm
      @save="save"
      @cancel="cancel"
      :emitClose="true"
      :locations="locations"
      :table="table"
      :tables="tables"
    />
  </div>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { saveItem } from '@/utils/crudFunctions'
import TableForm from '@/components/TableForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    TableForm
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    id: {
      required: true,
      type: Number
    },
    redirect: {
      required: false,
      type: String,
      default: null
    },
    redirectParams: {
      required: false,
      type: Object,
      default: null
    }
  },
  data () {
    return {
      oldTableValues: null,
      shown: false,
    }
  },
  computed: {
    table () {
      return this.$store.state.tables.items[this.id]
    },
    locations () {
      return objectToArray(this.$store.state.locations.items)
    },
    tables () {
      return objectToArray(this.$store.state.tables.items)
    }
  },
  methods: {
    ...mapActions('tables', { loadItem: 'loadItem', saveItem: 'saveItem', loadTables: 'loadItems' }),
    ...mapActions('locations', { loadLocations: 'loadItems' }),
    save ({ data }) {
      if (this.tableLocationWasChanged(data)) {
        data.sort_order = null
      }
      data.type = !data.type ? 0 : 1
      this.shown = false
      saveItem(data, this.redirect, this)
      this.$emit('close')
      /* this.$router.push({ name: this.redirect, params: this.redirectParams }) */
    },
    cancel () {
      // this.$router.push({ name: 'MyCompanyTables' })
      this.shown = false
      if (this.redirect) {
        this.$router.go(-1)
      } else {
        this.$emit('close')
      }
    },
    tableLocationWasChanged (data) {
      return this.oldTableValues.location !== data.location
    }
  },
  created () {
    this.shown = false
    Promise.all([
      this.loadLocations(),
      this.loadTables()
    ])
      .then(items => {
        this.asyncDataStatus_fetched()
        this.oldTableValues = this.table
        this.shown = true
      })
  }
}
</script>

<style scoped lang="scss">
  .popup {
    background-color: #fff;
    padding: 1rem;
    min-height: calc(100vh - 130px);
    /* overflow: auto; */
  }
</style>
